import { render } from "./ContactFormSugest.vue?vue&type=template&id=5289833b"
import script from "./ContactFormSugest.vue?vue&type=script&lang=js"
export * from "./ContactFormSugest.vue?vue&type=script&lang=js"
script.render = render

export default script